module.exports = __webpack_public_path__ + "static/github-security-alerts-b3f4fcf653fc768c6aed319ec15fe52c.png";